module.exports = __webpack_public_path__ + "img/eye-open.87b718d7.svg";